import { createAction, RSAAAction } from 'redux-api-middleware'
import queryString from 'query-string'

import { ActionLogsState } from '../reducers/actionLogs/state'
import { EstateUtils } from '../utils'
import { PayloadAction, ThunkRSAAAction } from './types'
import { ActionLog } from '../types'

export enum ActionLogsTypes {
    LOGS_FETCH_REQUEST = 'LOGS_FETCH##REQUEST',
    LOGS_FETCH_SUCCESS = 'LOGS_FETCH##SUCCESS',
    LOGS_FETCH_FAILURE = 'API_CALL##FAILURE',
    CHANGE_LOG_SEARCH = 'CHANGE_LOG_SEARCH',
    CHANGE_SELECTED_LOG = 'CHANGE_SELECTED_LOG',
}

export type FetchLogsPayload = {
    data: ActionLog[]
    current_page: Number
    per_page: Number
    total: Number
    from: Number
    to: Number
}

export type FetchLogsRSAAAction = RSAAAction<ActionLogsState, FetchLogsPayload, { pagination: Boolean; noFirstPage: Boolean }>

export type FetchLogsAction = PayloadAction<
    ActionLogsTypes.LOGS_FETCH_SUCCESS | ActionLogsTypes.LOGS_FETCH_FAILURE,
    FetchLogsPayload,
    { pagination: Boolean; noFirstPage: Boolean }
>

export type FetchLogsThunk = ThunkRSAAAction<FetchLogsAction, FetchLogsRSAAAction>

/**
 * Fetch countries information
 * @param {string} estate estate id
 */
export function fetchLogs({ search = '', order = null, orderType = null, page = 0, paginated = 1 }): FetchLogsThunk {
    const toQueryString = {
        search,
        order,
        orderType,
        page,
        paginated,
    }
    const query = queryString.stringify(toQueryString, {
        skipNull: true,
    })
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        const apiAction: FetchLogsRSAAAction = createAction({
            endpoint: `${api}/action_log?${query}`,
            method: 'GET',
            types: [
                ActionLogsTypes.LOGS_FETCH_REQUEST,
                {
                    type: ActionLogsTypes.LOGS_FETCH_SUCCESS,
                    meta: { pagination: true, noFirstPage: page > 1 },
                },
                ActionLogsTypes.LOGS_FETCH_FAILURE,
            ],
        })

        return dispatch(apiAction)
    }
}

export type ChangeLogSearchAction = PayloadAction<ActionLogsTypes.CHANGE_LOG_SEARCH, { search: string }>

export function changeLogSearch(search: string): ChangeLogSearchAction {
    return {
        type: ActionLogsTypes.CHANGE_LOG_SEARCH,
        payload: { search },
    }
}

export type ChangeSelectedLogAction = PayloadAction<ActionLogsTypes.CHANGE_SELECTED_LOG, { value: ActionLog }>

export function changeSelectedLog(value: ActionLog): ChangeSelectedLogAction {
    return {
        type: ActionLogsTypes.CHANGE_SELECTED_LOG,
        payload: { value },
    }
}

export type ActionLogsActions = FetchLogsAction | ChangeLogSearchAction | ChangeSelectedLogAction
